webpackJsonp([76],{

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(820);


/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(98);

var _datetime2 = _interopRequireDefault(_datetime);

var _es = __webpack_require__(566);

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('es', _es2.default);

/***/ })

},[1620]);


// WEBPACK FOOTER //
// app/datetime.es-108cb115c94912c31765.js